<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M2.85938 0.0625C1.78069 0.0625 0.90625 0.936943 0.90625 2.01562V19.9844C0.90625 21.0631 1.78069 21.9375 2.85937 21.9375H16.1406C17.2193 21.9375 18.0938 21.0631 18.0938 19.9844V11.7812C18.0938 9.62389 16.3449 7.875 14.1875 7.875H12.2344C11.1557 7.875 10.2812 7.00056 10.2812 5.92188V3.96875C10.2812 1.81139 8.53236 0.0625 6.375 0.0625H2.85938ZM4.8125 14.125C4.8125 13.6935 5.16228 13.3438 5.59375 13.3438H13.4062C13.8377 13.3438 14.1875 13.6935 14.1875 14.125C14.1875 14.5565 13.8377 14.9062 13.4062 14.9062H5.59375C5.16228 14.9062 4.8125 14.5565 4.8125 14.125ZM5.59375 16.4688C5.16228 16.4688 4.8125 16.8185 4.8125 17.25C4.8125 17.6815 5.16228 18.0312 5.59375 18.0312H9.5C9.93147 18.0312 10.2812 17.6815 10.2812 17.25C10.2812 16.8185 9.93147 16.4688 9.5 16.4688H5.59375Z"
                :fill="color" 
            />
            <path
                d="M10.5117 0.391567C11.3416 1.3505 11.8438 2.60099 11.8438 3.96875V5.92188C11.8438 6.13761 12.0186 6.3125 12.2344 6.3125H14.1875C15.5553 6.3125 16.8058 6.81462 17.7647 7.64459C16.8398 4.10404 14.0522 1.31643 10.5117 0.391567Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgDocument',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>